module.exports = __webpack_public_path__ + "img/Alejandro.97bc1cac.jpg";